/**
 * @generated SignedSource<<fb4e239244a0b2696c41762eb2569041>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type logsTableOfTabs_logEdges$data = ReadonlyArray<{
  readonly node: {
    readonly actionTimestamp: AGG$DateTime;
    readonly issueContext: {
      readonly issue: {
        readonly key: string;
        readonly webUrl: AGG$URL | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly notificationActionType: string | null | undefined;
    readonly notificationDetails: {
      readonly errorKey: string | null | undefined;
      readonly mailboxMessage: string | null | undefined;
    } | null | undefined;
    readonly recipient: {
      readonly accountId?: string;
      readonly email?: string | null | undefined;
      readonly name?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "logsTableOfTabs_logEdges";
}>;
export type logsTableOfTabs_logEdges$key = ReadonlyArray<{
  readonly " $data"?: logsTableOfTabs_logEdges$data;
  readonly " $fragmentSpreads": FragmentRefs<"logsTableOfTabs_logEdges">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isUnsuppressionEnabled"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "logsTableOfTabs_logEdges",
  "selections": [
    {
      "concreteType": "AquaOutgoingEmailLogItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "concreteType": "AquaIssueContext",
          "kind": "LinkedField",
          "name": "issueContext",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issue",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "key"
                },
                {
                  "kind": "ScalarField",
                  "name": "webUrl"
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "notificationActionType"
        },
        {
          "kind": "ScalarField",
          "name": "actionTimestamp"
        },
        {
          "concreteType": "AquaNotificationDetails",
          "kind": "LinkedField",
          "name": "notificationDetails",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "errorKey"
            },
            {
              "kind": "ScalarField",
              "name": "mailboxMessage"
            }
          ]
        },
        {
          "kind": "LinkedField",
          "name": "recipient",
          "plural": false,
          "selections": [
            {
              "condition": "isUnsuppressionEnabled",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "accountId"
                }
              ]
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                }
              ],
              "type": "AtlassianAccountUser"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ],
              "type": "CustomerUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "AquaOutgoingEmailLogItemEdge"
};

(node as any).hash = "a47e026d06670197abd7c2d3bdb3859c";

export default node;
